import { Injectable } from '@angular/core'
import { PlayHistoryApi } from './base'

@Injectable()
export class StaticContentPlayHistoryApi extends PlayHistoryApi{
  apiPath(resourceId: number, areaId = '') {
    return `static_contents/${resourceId}/play_histories/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-history/static-content.ts